<template>
  <div ref="tableBox" class="mandatory-list-wrap">
    <div class="filter-list">
      <div class="filter-item">
        <div class="item-label">
          状态
        </div>
        <div class="item-component">
          <div class="el-select-wrapper">
            <el-select v-model="status.value" placeholder="请选择" clearable @change="buildData">
              <el-option v-for="item in status.options" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="el-table-wrapper">
      <el-table :data="tableData" header-cell-class-name="custom-table-header-cell"
                cell-class-name="cell-class">
        <el-table-column type="index" width="20px" label="#"></el-table-column>
        <el-table-column label="类型" width="120px">
          <template slot-scope="scope">
            <i
              v-show="warningActivityIds && warningActivityIds.length && warningActivityIds.some(item => item === scope.row.actId)"
              class="el-icon-warning" style="color: red"></i>
            <span>{{ scope.row.typeText }}</span>
          </template>
        </el-table-column>
        <el-table-column property="summary" label="主题" min-width="100px" :show-overflow-tooltip="false">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" target="_blank"
                     :href="$util.buildSmsActivityDetailUrl(scope.row.actId)">
              {{ scope.row.summary }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column property="description" label="详情描述" min-width="100px"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="eventTypeText" label="事件类型" width="120px"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="eventReasonText" label="事件原因" width="80px"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :property="severityRaw ? 'severityText' : 'eventLevelText'" label="严重等级"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="safetyMeasures" label="安全措施" width="80px"
                         :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="statusText" label="状态" width="65px" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="reportTime" label="报告时间" width="120px"
                         :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
    <div class="page-wrapper">
      <el-pagination background layout="prev, pager, next" :total="page.total" :current-page.sync="page.num"
                     :page-size.sync="page.size">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getRequest, postRequest} from "../../utils/request";

export default {
  props: {
    company: String,
    year: Number,
    month: Number,
    //典型事件
    insecurity: String,
    //强制报告id
    activityIds: Array,
    //告警的安全信息（会在类型前面增加一个红色警告标志）
    warningActivityIds: Array,
    listById: Boolean,
    //true：显示原始严重等级，false：显示映射后的严重等级
    severityRaw: Boolean,
    eventReason: String,
  },
  data() {
    return {
      //表格数据
      tableData: [],
      //分页
      page: {
        num: 1,
        size: 5,
        total: null,
      },
      //状态
      status: {
        options: [{
          code: "FINISH",
          name: "结案"
        }, {
          code: "CLOSED",
          name: "关闭"
        }, {
          code: "INPROGRESS",
          name: "处理中"
        }],
        value: null
      },
    }
  },
  mounted() {
    this.buildData();
  },
  methods: {
    /**
     * 构建表格数据
     */
    buildData() {
      postRequest('/activity/mandatory/list', {
        company: this.company,
        year: this.year,
        month: this.month,
        status: this.status.value,
        insecurity: this.insecurity,
        activityIds: this.activityIds,
        listById: this.listById,
        eventReason: this.eventReason,
      }, {
        pageNum: this.page.num,
        pageSize: this.page.size
      }, this.$refs.tableBox).then(res => {
        this.tableData = res.data.records
        this.page.total = res.data.total
      })
    },
    initPage() {
      this.page.num = 1;
    },
  },
  watch: {
    company() {
      this.buildData();
    },
    year() {
      this.buildData();
    },
    month() {
      this.buildData();
    },
    insecurity() {
      this.buildData();
    },
    "page.num"() {
      this.buildData();
    }
  }
}
</script>

<style scoped lang="less">
.mandatory-list-wrap {
  .filter-list {
    display: flex;
    margin: 5px 0 10px 0;

    .filter-item {
      display: flex;
      align-items: center;

      .item-label {

      }

      .item-component {
        margin-left: 10px;
      }
    }

    .filter-item:not(:first-child) {
      margin-left: 10px;
    }
  }

  .el-table-wrapper {
    height: 40vh;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #c8c8c8;
    }

    /deep/ .custom-table-header-cell {
      color: #000;
    }

    /deep/ .cell-class {
      font-size: 13px;
      padding: 5px 0;
    }
  }

  .page-wrapper {
    text-align: center;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/MandatoryList.vue